(() => {
  const SELECTOR = "[data-ineffable-what-we-create]";

  function initializeSection(section) {
    if (
      !section ||
      section.dataset.whatWeCreateInitialized === "true"
    ) {
      return;
    }

    section.dataset.whatWeCreateInitialized = "true";

    const revealElements = Array.from(
      section.querySelectorAll("[data-iwwc-reveal]")
    );

    const itemElements = Array.from(
      section.querySelectorAll("[data-iwwc-item]")
    );

    const allElements = [
      ...revealElements,
      ...itemElements
    ];

    const revealAll = () => {
      allElements.forEach((element) => {
        element.classList.add("is-visible");
      });
    };

    if (
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches
    ) {
      revealAll();
      return;
    }

    if (!("IntersectionObserver" in window)) {
      revealAll();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: "0px 0px -6% 0px"
      }
    );

    allElements.forEach((element) => {
      observer.observe(element);
    });
  }

  function initializeAll(root = document) {
    root
      .querySelectorAll(SELECTOR)
      .forEach(initializeSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeAll()
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section =
        event.target.matches?.(SELECTOR)
          ? event.target
          : event.target.querySelector?.(SELECTOR);

      if (!section) {
        return;
      }

      section.dataset.whatWeCreateInitialized =
        "false";

      initializeSection(section);
    }
  );
})();